import { createAction } from '@reduxjs/toolkit';

import type { CSATUpdateConfig } from '@polyai/stream/protobuf/csat';

const PREFIX = 'csat';

export const updateCsatConfig = createAction<CSATUpdateConfig>(
  `${PREFIX}/updateConfig`,
);
